'use strict';

import powerWebp1x from '/img/projects/webp/power.webp';
import powerWebp2x from '/img/projects/webp/power-2x.webp';
import powerJpg1x from '/img/projects/jpg/power-min.jpg';
import powerJpg2x from '/img/projects/jpg/power-2x-min.jpg';

import miminoWebp1x from '/img/projects/webp/mimino.webp';
import miminoWebp2x from '/img/projects/webp/mimino-2x.webp';
import miminoJpg1x from '/img/projects/jpg/mimino-min.jpg';
import miminoJpg2x from '/img/projects/jpg/mimino-2x-min.jpg';

import vyshyvankaWebp1x from '/img/projects/webp/vyshyvanka.webp';
import vyshyvankaWebp2x from '/img/projects/webp/vyshyvanka-2x.webp';
import vyshyvankaJpg1x from '/img/projects/jpg/vyshyvanka-min.jpg';
import vyshyvankaJpg2x from '/img/projects/jpg/vyshyvanka-2x-min.jpg';

import greenWebp1x from '/img/projects/webp/green.webp';
import greenWebp2x from '/img/projects/webp/green-2x.webp';
import greenJpg1x from '/img/projects/jpg/green-min.jpg';
import greenJpg2x from '/img/projects/jpg/green-2x-min.jpg';

import walletWebp1x from '/img/projects/webp/wallet.webp';
import walletWebp2x from '/img/projects/webp/wallet-2x.webp';
import walletJpg1x from '/img/projects/jpg/wallet-min.jpg';
import walletJpg2x from '/img/projects/jpg/wallet-2x-min.jpg';

import chegoWebp1x from '/img/projects/webp/chego.webp';
import chegoWebp2x from '/img/projects/webp/chego-2x.webp';
import chegoJpg1x from '/img/projects/jpg/chego-min.jpg';
import chegoJpg2x from '/img/projects/jpg/chego-2x-min.jpg';

import energyWebp1x from '/img/projects/webp/energy.webp';
import energyWebp2x from '/img/projects/webp/energy-2x.webp';
import energyJpg1x from '/img/projects/jpg/energy-min.jpg';
import energyJpg2x from '/img/projects/jpg/energy-2x-min.jpg';

import fruitboxWebp1x from '/img/projects/webp/fruitbox.webp';
import fruitboxWebp2x from '/img/projects/webp/fruitbox-2x.webp';
import fruitboxJpg1x from '/img/projects/jpg/fruitbox-min.jpg';
import fruitboxJpg2x from '/img/projects/jpg/fruitbox-2x-min.jpg';

import englishWebp1x from '/img/projects/webp/english.webp';
import englishWebp2x from '/img/projects/webp/english-2x.webp';
import englishJpg1x from '/img/projects/jpg/english-min.jpg';
import englishJpg2x from '/img/projects/jpg/english-2x-min.jpg';

import starlightWebp1x from '/img/projects/webp/starlight.webp';
import starlightWebp2x from '/img/projects/webp/starlight-2x.webp';
import starlightJpg1x from '/img/projects/jpg/starlight-min.jpg';
import starlightJpg2x from '/img/projects/jpg/starlight-2x-min.jpg';

const projects = [
  {
    images: {
      webp: {
        '1x': powerWebp1x,
        '2x': powerWebp2x,
      },
      jpg: {
        '1x': powerJpg1x,
        '2x': powerJpg2x,
      },
    },
    skills: 'React, JavaScript, Node JS, Git',
    title: 'power pulse webservice',
  },
  {
    images: {
      webp: {
        '1x': miminoWebp1x,
        '2x': miminoWebp2x,
      },
      jpg: {
        '1x': miminoJpg1x,
        '2x': miminoJpg2x,
      },
    },
    skills: 'React, JavaScript, Node JS, Git',
    title: 'mimino website',
  },
  {
    images: {
      webp: {
        '1x': vyshyvankaWebp1x,
        '2x': vyshyvankaWebp2x,
      },
      jpg: {
        '1x': vyshyvankaJpg1x,
        '2x': vyshyvankaJpg2x,
      },
    },
    skills: 'React, JavaScript, Node JS, Git',
    title: 'vyshyvanka vibes Landing Page',
  },
  {
    images: {
      webp: {
        '1x': greenWebp1x,
        '2x': greenWebp2x,
      },
      jpg: {
        '1x': greenJpg1x,
        '2x': greenJpg2x,
      },
    },
    skills: 'React, JavaScript, Node JS, Git',
    title: 'green harvest online store',
  },
  {
    images: {
      webp: {
        '1x': walletWebp1x,
        '2x': walletWebp2x,
      },
      jpg: {
        '1x': walletJpg1x,
        '2x': walletJpg2x,
      },
    },
    skills: 'React, JavaScript, Node JS, Git',
    title: 'wallet webservice',
  },
  {
    images: {
      webp: {
        '1x': chegoWebp1x,
        '2x': chegoWebp2x,
      },
      jpg: {
        '1x': chegoJpg1x,
        '2x': chegoJpg2x,
      },
    },
    skills: 'React, JavaScript, Node JS, Git',
    title: 'chego jewelry website',
  },
  {
    images: {
      webp: {
        '1x': energyWebp1x,
        '2x': energyWebp2x,
      },
      jpg: {
        '1x': energyJpg1x,
        '2x': energyJpg2x,
      },
    },
    skills: 'React, JavaScript, Node JS, Git',
    title: 'energy flow webservice',
  },
  {
    images: {
      webp: {
        '1x': fruitboxWebp1x,
        '2x': fruitboxWebp2x,
      },
      jpg: {
        '1x': fruitboxJpg1x,
        '2x': fruitboxJpg2x,
      },
    },
    skills: 'React, JavaScript, Node JS, Git',
    title: 'fruitbox online store',
  },
  {
    images: {
      webp: {
        '1x': englishWebp1x,
        '2x': englishWebp2x,
      },
      jpg: {
        '1x': englishJpg1x,
        '2x': englishJpg2x,
      },
    },
    skills: 'React, JavaScript, Node JS, Git',
    title: 'english excellence webservice',
  },
  {
    images: {
      webp: {
        '1x': starlightWebp1x,
        '2x': starlightWebp2x,
      },
      jpg: {
        '1x': starlightJpg1x,
        '2x': starlightJpg2x,
      },
    },
    skills: 'React, JavaScript, Node JS, Git',
    title: 'starlight studio landing page',
  },
];

export default projects;
